/* ==========================================================================
   ESTASY — core theme JS
   Drawers, header sticky behaviour, accordions, sticky mobile ATC, qty.
   No dependencies.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Drawer system (mobile menu, cart, search, filters) ---------- */
  const Drawers = {
    open(id, trigger) {
      const drawer = document.getElementById(id);
      if (!drawer) return;
      const overlay = document.querySelector('[data-drawer-overlay]');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');
      drawer.dataset.trigger = trigger ? trigger.id || '' : '';
      // focus first focusable
      const focusable = drawer.querySelector('button, a, input, [tabindex]');
      if (focusable) focusable.focus();
      document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id } }));
    },
    close(drawer) {
      if (typeof drawer === 'string') drawer = document.getElementById(drawer);
      if (!drawer) return;
      const overlay = document.querySelector('[data-drawer-overlay]');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      if (!document.querySelector('.drawer.is-open')) document.body.classList.remove('no-scroll');
    },
    closeAll() {
      document.querySelectorAll('.drawer.is-open').forEach((d) => this.close(d));
    }
  };
  window.EstasyDrawers = Drawers;

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      Drawers.open(openBtn.getAttribute('data-drawer-open'), openBtn);
      return;
    }
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      Drawers.close(closeBtn.closest('.drawer'));
      return;
    }
    if (e.target.matches('[data-drawer-overlay]')) Drawers.closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') Drawers.closeAll();
  });

  /* ---------- Sticky header shadow on scroll ---------- */
  const header = document.querySelector('[data-header]');
  if (header && header.classList.contains('is-sticky')) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Sticky mobile add-to-cart reveal ---------- */
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const atcAnchor = document.querySelector('[data-atc-anchor]');
  if (stickyAtc && atcAnchor && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(atcAnchor);
  }

  /* ---------- Quantity selectors ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('.qty');
    const input = wrap.querySelector('input');
    const step = btn.getAttribute('data-qty-change') === 'increase' ? 1 : -1;
    const min = parseInt(input.min || '1', 10);
    let val = parseInt(input.value || '1', 10) + step;
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Single-open accordions are native <details>; no JS needed ---------- */

  /* ---------- Footer columns: collapsed accordion on mobile, open on desktop ---------- */
  (function () {
    const mq = window.matchMedia('(min-width: 750px)');
    function sync() {
      document.querySelectorAll('.footer__col').forEach((d) => { d.open = mq.matches; });
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  })();

  /* ---------- Newsletter / forms graceful states handled by Shopify ---------- */
})();
